export const TEMPLATE_TYPE = {
  ANTI_FAKE_TRACE: 1,
  BOX_ANTI_FAKE: 2,
  MARKETING: 3,
  MARKETING_WHEEL: 4,
  GUIDE: 5,
};

export const TEMPLATE_TYPE_MAP = {
  [TEMPLATE_TYPE.ANTI_FAKE_TRACE]: '防伪溯源模板',
  [TEMPLATE_TYPE.BOX_ANTI_FAKE]: '箱标防伪模板',
  [TEMPLATE_TYPE.MARKETING]: '营销活动模版',
  [TEMPLATE_TYPE.MARKETING_WHEEL]: '营销活动大转盘',
  [TEMPLATE_TYPE.GUIDE]: '导购',
};

export const TEMPLATE_TYPE_OPTIONS = Object.entries(TEMPLATE_TYPE_MAP).map(([value, label]) => ({
  value: Number(value),
  label,
}));
